module.exports = __webpack_public_path__ + "officialStatic/img/schoolBg3.aafc11e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/schoolBg3.jpg
// module id = 90bZ
// module chunks = 0